// extracted by mini-css-extract-plugin
module.exports = {"horizontal-line":"horizontal-line__B7fkr"};